import { Component } from '@angular/core';

@Component({
  selector: 'style-guide',
  templateUrl: './style-guide.component.html',
  styleUrls: ['./style-guide.component.scss'],
  standalone: false,
})
export class StyleGuideComponent {}
